define('v3/Common/Components/FileUpload/FileUpload.Component',[
	'jquery',
	'knockout',
	'lodash',
	'text!v3/Common/Components/FileUpload/FileUpload.Component.html',
	'v3/Common/Services/frontend/Frontend.Service',
	'v3/Common/Bindings/SvgIcon.Binding'
], function ($, ko, _, htmlString, frontend) {
	function validateParams (params) {
		if (!ko.isObservable(params.element)) {
			throw new Error('params.element is not observable.');
		}
		if (params.accept && !_.isArray(params.accept)) {
			throw new Error('params.accept is not an array.');
		}
	}

	function DropdownViewModel (params) {
		var self = this;
		validateParams(params);

		self.fileName = params.fileName || ko.observable(false);
		self.filePreview = params.filePreview || ko.observable(params.fileName() || false);
		self.fileElement = params.element;
		self.acceptedTypes = ko.observableArray(params.accept || ['image/*']);
		self.previewIcon = params.previewIcon || ko.observable('Browser');
		self.showPreview = params.showPreview || ko.observable(false);
		self.ChangeFileString = ko.pureComputed(function () {
			return self.fileName() ? Strings.UpdateFile : Strings.SelectFile;
		}, this);

		if (self.fileName()) {
			var total = self.fileName().split('/');
			self.fileName(total[total.length - 1]);
		}

		self.chooseFile = function (element, event) {
			$(event.delegateTarget).prev('input[type="file"]').trigger('click');
		};

		self.getFile = function (input) {
			if (input.value === '') {
				self.filePreview('');
				self.fileElement({ data: undefined, file: undefined });
				self.fileName('');
				return;
			}

			if (input.files && input.files[0]) {
				var reader = new FileReader();

				reader.onload = function (e) {
					self.filePreview(e.target.result);
					self.fileElement({ data: input.files[0], file: e.target.result });
				};

				self.fileName(input.files[0].name);
				reader.readAsDataURL(input.files[0]);
			} else {
				frontend.notification.error(Strings.FileReaderError);
			}
		};

		self.clearFile = function (vm, event) {
			var formReset = $(event.delegateTarget).parents('form');

			if (formReset) { formReset[0].reset(); }

			self.fileName(false);
			self.filePreview(false);
			self.fileElement(false);
		};
	}

	return { viewModel: DropdownViewModel, template: htmlString };
});
